/** @format */

import MessageHistoryActionTypes from './message-history.types';

export const fetchMessageHistoryStart = (flightIds) => ({
  type: MessageHistoryActionTypes.FETCH_MESSAGE_HISTORY_START,
  payload: flightIds,
});

export const fetchMessageHistorySuccess = (messageHistory) => ({
  type: MessageHistoryActionTypes.FETCH_MESSAGE_HISTORY_SUCCESS,
  payload: messageHistory,
});

export const fetchMessageHistoryFailure = (error) => ({
  type: MessageHistoryActionTypes.FETCH_MESSAGE_HISTORY_FAILURE,
  payload: error,
});
